export default __webpack_public_path__ + "static/media/IMAGEM DOS PRODUTOS - APPLE.58ab163b.png";